import { render, staticRenderFns } from "./ReviewPanel.vue?vue&type=template&id=2a7a5b2d&scoped=true"
import script from "./ReviewPanel.vue?vue&type=script&lang=js"
export * from "./ReviewPanel.vue?vue&type=script&lang=js"
import style0 from "./ReviewPanel.vue?vue&type=style&index=0&id=2a7a5b2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a5b2d",
  null
  
)

export default component.exports